<template>
  <div class="statistics">
    statistics
  </div>
</template>
<script>
  export default {
    name: 'statistics'
  }
</script>
<style lang="less" scoped>
  
</style>
